import axios from "axios";
import {
  AccusedProsecutor,
  AccusedSummon,
  Appeal,
  AssignedProsecutor,
  CollectedEvidence,
  CollectedVictim,
  Complaints,
  CouncilLitigation,
  CouncilOfficeVerdictInitialDay,
  CourtAppeal,
  DocumentEvidence,
  Investigation,
  InvestigationComment,
  Litigation,
  MobileDeciplineReport,
  Prosecutor,
  Summon,
} from "types";
import apiClient from "../lib/apiClients";

export const fetchProsecutor = async () => {
  const response = await apiClient.get<Prosecutor[]>(
    "/prosecutor-decipiline/prosecutors/",
  );
  return response.data;
};

export const fetchAssignedProsecutor = async (
  adminUnit: string,
  orgUnit: string,
  token: string,
) => {
  const url = `/prosecutor-decipiline/complaints/fetch-employees-by-org/`;
  const response = await apiClient.get<AssignedProsecutor[]>(
    `${url}?admin_id=${adminUnit}&org_id=${orgUnit}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const fetchRe_AssignedProsecutor = async (
  adminUnit: string,
  orgUnit: string,
  token: string,
) => {
  const url = `/prosecutor-decipiline/litigation-verdict-prosecutor/fetch-employees-by-org/`;
  const response = await apiClient.get<AssignedProsecutor[]>(
    `${url}?admin_id=${adminUnit}&org_id=${orgUnit}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const fetchAccusedProsecutor = async (
  name: string,
  admin_unit: string,
  woreda: string = "",
  zone: string = "",
) => {
  // let url = `/prosecutor-decipiline/complaints/search-employeebyname/?name=${name}&admin_unit_uuid=${admin_unit}`;
  let url = `/prosecutor-decipiline/complaints/search-employee/?name=${name}&admin_unit_uuid=${admin_unit}&zone=${zone}&wereda=${woreda}`;
  // const url = `// let url = `discipline-api.oagb.et/api/prosecutor-decipiline/complaints/search-employeebyname/?name=${name}&admin_unit_uuid=${admin_unit}`;
  if (woreda) {
    url += `&wereda=${woreda}`;
  }
  if (zone) {
    url += `&zone=${zone}`;
  }
  const response = await apiClient.get<AccusedProsecutor[]>(url);

  return response.data?.map((obj: any) => ({
    uu_id: obj?.uu_id,
    english_first_name: obj?.english_first_name,
    english_middle_name: obj?.english_middle_name,
    english_last_name: obj?.english_last_name,
    full_name: `${obj?.english_first_name} ${obj?.english_middle_name} ${obj?.english_last_name}`,
    employee_type: obj?.employee_type?.name,
    woreda: obj?.woreda,
    zone: obj?.zone,
    status: obj?.status,
    mobile_phone_number: obj?.mobile_phone_number,
    gender: obj?.gender,
    // admin_unit: obj?.employee_type?.admin_level?.uu_id,
    admin_unit: obj?.admin_unit_uuid,
    org_unit: obj?.org_unit,
  }));
};

export const fetchEmployees = async (query: string) => {
  const response = await apiClient.get<any[]>(
    `/prosecutor-decipiline/complaints/search-employeebyname/?name=${query}`,
  );
  return response.data;
};

export const fetchCouncilDecisionTypes = async () => {
  const response = await apiClient.get<Complaints[]>(
    "/base_data/council-decision-types/",
  );
  return response.data;
};

export const fetchAppealCouncilDecisionTypes = async () => {
  const response = await apiClient.get<Complaints[]>(
    "/base_data/appeal-council-decision-types/",
  );
  return response.data;
};

export const fetchAppealProsecutorDecisionTypes = async () => {
  const response = await apiClient.get<Complaints[]>(
    "/base_data/appeal-prosecutor-decision-types/",
  );
  return response.data;
};

export const fetchDecisionMeasureTypes = async () => {
  const response = await apiClient.get<Complaints[]>(
    "/base_data/discipline-measure-types/",
  );
  return response.data;
};

export const fetchAppealDecisionMeasureTypes = async () => {
  const response = await apiClient.get<Complaints[]>(
    "/base_data/appeal-discipline-measure-types/",
  );
  return response.data;
};

export const fetchOffenseTypes = async () => {
  const response = await apiClient.get<Complaints[]>(
    "/base_data/offence-types-prosecutor/",
  );
  return response.data;
};

export const fetchComplaintLogs = async () => {
  const response = await apiClient.get<any[]>("/prosecutor-decipiline/logs/");
  return response.data;
};

export const fetchLogsByComplaintId = async (id: string | number) => {
  const response = await apiClient.get<any[]>(
    `/prosecutor-decipiline/logs/by-complaint/${id}`,
  );
  return response.data;
};

export const fetchComplaint = async () => {
  const response = await apiClient.get<Complaints[]>(
    "/prosecutor-decipiline/complaints/",
  );
  return response.data;
};
export const fetchComplaintForProsecutor = async (
  prosecutor_id: string | number,
) => {
  const response = await apiClient.get<Complaints[]>(
    `/prosecutor-decipiline/complaints/assigned-direct/?assigned_prosecutor_id=${prosecutor_id}`,
  );
  return response.data;
};
export const fetchComplaintByAdminUnit = async (
  admin_unit: string | number,
) => {
  const response = await apiClient.get<Complaints[]>(
    `/prosecutor-decipiline/complaints/by-admin-unit/?admin_unit_id=${admin_unit}`,
  );
  return response.data;
};
export const searchComplaint = async (search: string) => {
  const response = await apiClient.get<Complaints[]>(
    `/prosecutor-decipiline/complaints/search-by-accused/?name=${search}`,
  );
  return response.data;
};

export const fetchComplaintById = async (uu_id: string) => {
  const response = await apiClient.get<Complaints[]>(
    "/prosecutor-decipiline/complaints/" + uu_id + "/",
  );
  return response.data;
};

export const addComplaint = async (complaint: Complaints) => {
  const response = await apiClient.post("/prosecutor-decipiline/complaints/", {
    ...complaint,
  });
  return response.data;
};

export const editComplaint = async (complaint: Complaints) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/complaints/" + complaint?.uu_id + "/",
    complaint,
  );
  return response.data;
};
export const editComplaintFormData = async (
  complaint: FormData,
  complaint_id: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/complaints/" + complaint_id + "/",
    isFormData ? complaint : { ...complaint },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const deleteComplaint = async (complaint: Complaints) => {
  const response = await apiClient.delete(
    "/prosecutor-decipiline/complaints/" + complaint?.uu_id + "/",
  );
  return response.data;
};

export const addComplaintEvidence = async (
  formData: CollectedEvidence | FormData,
): Promise<any> => {
  try {
    const response = await apiClient.post(
      "/prosecutor-decipiline/evidences/",
      formData as FormData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
  } catch (error) {
    console.error("Error adding complaint evidence:", error);
    throw error;
  }
};

export const addEvidenceAttachment = async (
  attachment: DocumentEvidence | FormData,
  isFormData: boolean = true,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/attachments/",
    isFormData ? attachment : { ...attachment },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const addComplaintVictim = async (
  victim: CollectedVictim | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/victims/",
    isFormData ? victim : { ...victim },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const addComplaintReporter = async (
  reporter: CollectedVictim | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/reporters/",
    isFormData ? reporter : { ...reporter },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const addComplaintWitness = async (
  witness: CollectedVictim | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/witnesses/",
    isFormData ? witness : { ...witness },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchInvestigation = async () => {
  const response = await apiClient.get<Investigation[]>(
    "/prosecutor-decipiline/investigations/",
  );
  return response.data;
};

export const fetchInvestigationByComplaintId = async (complaintId: string) => {
  const response = await apiClient.get<Investigation[]>(
    "/prosecutor-decipiline/complaints/" + complaintId + "/investigations",
  );
  return response.data;
};

export const addInvestigation = async (
  investigation: Investigation | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/investigations/",
    isFormData ? investigation : { ...investigation },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editInvestigation = async (
  investigation: Investigation | FormData,
  investigation_id: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/investigations/" + investigation_id + "/",
    isFormData ? investigation : { ...investigation },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editInvestigation2 = async (
  investigation: any,
  investigation_id: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.patch(
    "/prosecutor-decipiline/investigations/" + investigation_id + "/",
    isFormData ? investigation : { ...investigation },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const addFurtherInvestigation = async (investigation: any) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/further-investigations/",
    investigation,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return response.data;
};

export const fetchInvestigationFeedbackByInvestigationId = async (
  investigationId: string,
) => {
  const response = await apiClient.get<InvestigationComment[]>(
    // "/prosecutor-decipiline/director-decision-feedbacks/" + investigationId
    "/prosecutor-decipiline/director-decision-feedbacks/",
  );
  return response.data;
};

export const addInvestigationFeedback = async (
  investigation: InvestigationComment | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/director-decision-feedbacks/",
    isFormData ? investigation : { ...investigation },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchChargeFeedbackByInvestigationId = async (
  investigationId: string,
) => {
  const response = await apiClient.get<InvestigationComment[]>(
    // "/prosecutor-decipiline/director-charge-feedbacks/" + investigationId
    "/prosecutor-decipiline/director-charge-feedbacks/",
  );
  return response.data;
};

export const addInvestigationEvaluation = async (evaluation: any) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/investigation-evaluations/",
    evaluation,
  );
  return response.data;
};

export const addChargeDocFeedback = async (
  investigation: InvestigationComment | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/director-charge-feedbacks/",
    isFormData ? investigation : { ...investigation },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchChargeFeedbackByCouncilByInvestigationId = async (
  investigationId: string,
) => {
  const response = await apiClient.get<InvestigationComment[]>(
    // "/prosecutor-decipiline/council-writer-charge-feedbacks/" + investigationId
    "/prosecutor-decipiline/council-writer-charge-feedbacks/",
  );
  return response.data;
};

export const addChargeDocFeedbackByCouncil = async (
  investigation: InvestigationComment | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/council-writer-charge-feedbacks/",
    isFormData ? investigation : { ...investigation },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchSummonByInvestigationId = async (investigationId: string) => {
  const response = await apiClient.get<Summon[]>(
    "/prosecutor-decipiline/investigations/" + investigationId + "/summons/",
  );
  return response.data;
};

export const addSummon = async (
  summon: Summon | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/issue-summons/",
    isFormData ? summon : { ...summon },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editSummon = async (
  summonData: Summon | FormData,
  summon_id: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/issue-summons/" + summon_id + "/",
    isFormData ? summonData : { ...summonData },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editSummon2 = async (
  summonData: Summon | FormData,
  summon_id: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.patch(
    "/prosecutor-decipiline/issue-summons/" + summon_id + "/",
    isFormData ? summonData : { ...summonData },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchLitigationBySummonId = async (summonId: string) => {
  const response = await apiClient.get<Litigation[]>(
    "/prosecutor-decipiline/litigation-verdicts/by-complaint/" + summonId,
  );
  return response.data;
};

export const addLitigation = async (
  data: Litigation | FormData | any,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/litigation-verdicts/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editLitigation = async (
  data: Litigation | FormData,
  litigationId: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/litigation-verdicts/" + litigationId + "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};
export const editLitigationPatch = async (
  data: any,
  litigationId: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.patch(
    "/prosecutor-decipiline/litigation-verdicts/" + litigationId + "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchLitigationFeedbacks = async () => {
  const response = await apiClient.get<CouncilLitigation[]>(
    "/prosecutor-decipiline/director-feedbacks/",
  );
  return response.data;
};

export const addLitigationFeedback = async (data: any) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/director-feedbacks/",
    data,
  );
  return response.data;
};

export const fetchCouncilLitigationBySummonId = async (summonId: string) => {
  const response = await apiClient.get<CouncilLitigation[]>(
    "/prosecutor-decipiline/counciloffice-verdicts/by-summon/" + summonId,
  );
  return response.data;
};

export const addCouncilLitigation = async (
  data: CouncilLitigation | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/counciloffice-verdicts/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editCouncilLitigation = async (
  data: CouncilLitigation | FormData,
  litigationId: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/counciloffice-verdicts/" + litigationId + "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editCouncilLitigation2 = async (
  data: any,
  litigationId: string,
) => {
  const response = await apiClient.patch(
    "/prosecutor-decipiline/counciloffice-verdicts/" + litigationId + "/",
    { ...data },
  );
  return response.data;
};

export const addCouncilLitigationAttendance = async (data: any) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/council-member-attendance/",
    data,
  );
  return response.data;
};

export const fetchAppealByComplaintId = async (complaintId: string) => {
  const response = await apiClient.get<Appeal[]>(
    // "/prosecutor-decipiline/appeals/"
    "/prosecutor-decipiline/appeals/by-complaint/" + complaintId + "/",
  );
  return response.data;
};

export const fetchCouncilOfficeVErdictByComplaintId = async (
  complaintId: string,
) => {
  const response = await apiClient.get<CouncilLitigation[]>(
    // "/prosecutor-decipiline/appeals/"
    "/prosecutor-decipiline/counciloffice-verdicts/by-complaint/?complaint_id=" +
      complaintId,
  );
  return response.data;
};

export const requestAppeal = async (
  data: FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/appeals/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editAppeal = async (
  data: Appeal | FormData,
  appeal_id: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/appeals/" + appeal_id + "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editAppeal2 = async (data: any, appeal_id: string) => {
  const response = await apiClient.patch(
    "/prosecutor-decipiline/appeals/" + appeal_id + "/",
    { ...data },
  );
  return response.data;
};

export const editAppeal3 = async (
  data: Appeal | FormData,
  appeal_id: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.patch(
    "/prosecutor-decipiline/appeals/" + appeal_id + "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchSummonByAppealId = async (appealId: string) => {
  const response = await apiClient.get<Summon[]>(
    "/prosecutor-decipiline/issue-summon-appeals/by-appeal-request/" +
      appealId +
      "/",
  );
  return response.data;
};

export const addAppealSummon = async (
  summon: Summon | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/issue-summon-appeals/",
    isFormData ? summon : { ...summon },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editAppealSummon = async (
  summonData: Summon | FormData,
  summon_id: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/issue-summon-appeals/" + summon_id + "/",
    isFormData ? summonData : { ...summonData },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editAppealSummon2 = async (summonData: any, summon_id: string) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/issue-summon-appeals/" + summon_id + "/",
    { ...summonData },
  );
  return response.data;
};

export const fetchAppealAssignmentHistory = async () => {
  const response = await apiClient.get<any[]>(
    "/prosecutor-decipiline/issuesummonappeal-assignment-history/",
  );
  return response.data;
};

export const fetchAppealLitigationByAppealSummonId = async (
  summonId: string,
) => {
  const response = await apiClient.get<Litigation[]>(
    "/prosecutor-decipiline/appeal-litigation-verdict-prosecutors/",
    // "/prosecutor-decipiline/appeal-litigation-verdict/by-complaint/" + summonId
  );
  return response.data;
};

export const addAppealLitigation = async (
  data: Litigation | FormData | any,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/appeal-litigation-verdict-prosecutors/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editAppealLitigation = async (
  data: Litigation | FormData,
  litigationId: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/appeal-litigation-verdict-prosecutors/" +
      litigationId +
      "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchAppealLitigationFeedbacks = async () => {
  const response = await apiClient.get<CouncilLitigation[]>(
    "/prosecutor-decipiline/appeal-director-feedbacks/",
  );
  return response.data;
};

export const addAppealLitigationFeedback = async (data: any) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/appeal-director-feedbacks/",
    data,
  );
  return response.data;
};

export const fetchAppealCouncilLitigationByAppealSummonId = async (
  summonId: string,
) => {
  const response = await apiClient.get<CouncilLitigation[]>(
    "/prosecutor-decipiline/appeal_litigation-verdict-council-office/",
    // "/prosecutor-decipiline/appeal-litigation-verdict-council-office/by-summon/" + summonId
  );
  return response.data;
};

export const addAppealCouncilLitigation = async (
  data: CouncilLitigation | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/appeal_litigation-verdict-council-office/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editAppealCouncilLitigation = async (
  data: CouncilLitigation | FormData,
  litigationId: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/appeal_litigation-verdict-council-office/" +
      litigationId +
      "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editAppealCouncilLitigation2 = async (
  data: any,
  litigationId: string,
) => {
  const response = await apiClient.patch(
    "/prosecutor-decipiline/appeal_litigation-verdict-council-office/" +
      litigationId +
      "/",
    { ...data },
  );
  return response.data;
};

export const addAppealCouncilLitigationAttendance = async (data: any) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/appeal-council-member-attendance/",
    data,
  );
  return response.data;
};

export const fetchAccusedSummonByComplaintId = async (complaintId: string) => {
  const response = await apiClient.get<AccusedSummon[]>(
    // "/prosecutor-decipiline/issue-summons_accused/"
    "/prosecutor-decipiline/issue-summons_accused/by-complaint/" + complaintId,
  );
  return response.data;
};

export const addAccusedSummon = async (
  summon: AccusedSummon | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/issue-summons_accused/",
    isFormData ? summon : { ...summon },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editAccusedSummon = async (
  data: AccusedSummon | FormData,
  accusedSummonId: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/issue-summons_accused/" + accusedSummonId + "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const addAccusedSummonFeedback = async (
  data: any,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/appeal-feedback/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchAccusedAssignmentHistory = async () => {
  const response = await apiClient.get<any[]>(
    "/prosecutor-decipiline/issuesummonappeal-accused-assignment-history/",
  );
  return response.data;
};

export const fetchCourtAppealByComplaintId = async (complaintId: string) => {
  const response = await apiClient.get<CourtAppeal[]>(
    // "/prosecutor-decipiline/appeals-to-court/"
    "/prosecutor-decipiline/appeals-to-court/by-complaint/" + complaintId,
  );
  return response.data;
};

export const addCourtAppeal = async (
  data: CourtAppeal | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/appeals-to-court/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editCourtAppeal = async (
  data: CourtAppeal | FormData,
  courtAppealId: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/appeals-to-court/" + courtAppealId + "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchCourtAssignmentHistory = async () => {
  const response = await apiClient.get<any[]>(
    "/prosecutor-decipiline/appeal-accused-prosecutor-court-assignment-history/",
  );
  return response.data;
};

export const fetchZoneByAdminUnit = async (
  admin_unit: string,
  org_unit: string,
) => {
  const response = await apiClient.get<any[]>(
    "/prosecutor-decipiline/complaints/user-org-details/?admin_unit_uuid=" +
      admin_unit +
      "&org_unit_uuid=" +
      org_unit,
  );
  return response.data;
};

export const fetchLitigationCouncilofficeDocuments = async (type: string) => {
  const response = await apiClient.get<CouncilLitigation>(
    `/prosecutor-decipiline/litigation-counciloffice-documents/?document_type=${type}`,
  );
  return response.data;
};

// decipline report by mobile
export const fetchDicipline = async () => {
  const response = await apiClient.get<MobileDeciplineReport[]>(
    "/prosecutor-decipiline/mobile-complaints/",
  );
  return response.data;
};

export const fetchDiciplineById = async (id: string | number) => {
  const response = await apiClient.get<MobileDeciplineReport>(
    "/prosecutor-decipiline/mobile-complaints/" + id + "/",
  );
  return response.data;
};

export const updateMobileComplaintStatus = async (
  id: string | number,
  status: string,
) => {
  const response = await apiClient.put<MobileDeciplineReport>(
    "/prosecutor-decipiline/mobile-complaints/" + id + "/",
    { status },
  );
  return response.data;
};

// CouncilOfficeVerdictInitialDay
export const addVerdictInitialDay = async (
  data: CouncilOfficeVerdictInitialDay | FormData,
  isFormData: boolean = false,
) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/counciloffice-verdict-initialday/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const editVerdictInitialDay = async (
  data: CouncilOfficeVerdictInitialDay | FormData,
  litigationId: string,
  isFormData: boolean = false,
) => {
  const response = await apiClient.put(
    "/prosecutor-decipiline/counciloffice-verdict-initialday/" +
      litigationId +
      "/",
    isFormData ? data : { ...data },
    isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {},
  );
  return response.data;
};

export const fetchAppealDateValidation = async () => {
  const response = await apiClient.get<{ id: number; name: string }[]>(
    "/base_data/appeal_date_validation/",
  );
  return response.data;
};

export const fetchStampByAdminUnitAdminAndServiceName = async (
  admin_unit: string,
  service_name = "ccms",
) => {
  const response = await axios.get<any>(
    `${process.env.REACT_APP_API_BASE_URL_2}organization/service-stamp/read_stamp/?admin_unit_uuid=${admin_unit}&service_name=${service_name}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
      },
    },
  );
  return response.data;
};

export const fetchFile = async (url: string) => {
  const response = await axios.get<any>(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
    },
  });
  return response.data;
};

export const addAppealEvaluation = async (evaluation: any) => {
  const response = await apiClient.post(
    "/prosecutor-decipiline/appeal-evaluations/",
    evaluation,
  );
  return response.data;
};
